import React, { useState, useCallback } from 'react';

import { SegmentedButton, Spacer, Radios, Textarea, Flexer, Button } from '@ontruck/orc';

import ShipperOrderTag from 'modules/shipper-order/Tag';

import { StyledItem, StyledInline } from 'modules/log/LogItem/styled';

import ActionName from 'modules/log/LogItem/modes/common/ActionName';
import Changes from 'modules/log/LogItem/modes/common/Changes';

import useEditionMode from 'modules/log/LogItem/modes/common/useEditionMode';

import t_logs from 'modules/log/t-logs';
import tlogs_es from 'modules/log/t-logs_es';
import { IS_TENANT } from 'tenant/config';

import {
  LOG_INFO,
  LOG_INCIDENT,
  LOG_REASONS,
  LOG_LOG_TYPE_BY_DEFAULT,
  LOG_REASON_BY_DEFAULT,
  LOG_SHOW_LOG_TYPE,
  LOG_SHOW_REASONS,
  ACTIONS_WITHOUT_COMMENT_FIELD,
} from 'modules/log/log-reasons';
import { injectIntl } from 'react-intl';

const EditModeExtended = ({
  comment,
  action,
  shipperOrdersSkin = {},
  shipper_order_id,
  journey_id,
  onSubmit,
  changes,
  id,
  intl,
}) => {
  const defaultLogType = LOG_LOG_TYPE_BY_DEFAULT[action];
  const defaultReason = LOG_REASON_BY_DEFAULT[action];
  const t = intl.messages.modules.logs.log_item;
  const showComment = !ACTIONS_WITHOUT_COMMENT_FIELD.includes(action);
  const shipperOrders = Object.keys(shipperOrdersSkin);
  const multipleShipperOrders = shipperOrders.length > 1;

  const [reason, setReason] = useState(defaultReason);

  const {
    comment: commentEdited,
    logType,
    handleTextareaChange,
    handleLogTypeChange,
    textAreaRef,
  } = useEditionMode({ defaultComment: comment, defaultLogType });

  const handleReasonChange = useCallback(
    (e, { value }) => {
      setReason(value);
    },
    [setReason]
  );

  const handleSaveClick = useCallback(() => {
    onSubmit &&
      onSubmit({
        journeyId: journey_id,
        shipperOrderId: shipper_order_id,
        id,
        reason,
        log_type: logType,
        comment: commentEdited,
        type: 'extendedCreation',
      });
  }, [onSubmit, id, commentEdited, logType, reason, journey_id, shipper_order_id]);
  const logs_messages = IS_TENANT ? tlogs_es : t_logs;
  const saveButtonText = t.new_entry;
  const subTitle = logs_messages.titles[action];
  const reasonsText = logs_messages.reasons;
  const showLogType = LOG_SHOW_LOG_TYPE[action];
  const showReasons = LOG_SHOW_REASONS[action];

  return (
    <StyledItem background="grey200">
      <Flexer.Parent alignItems="center" mBottom="XS">
        <Flexer.Child flex="1">
          <ActionName action={action} bold color="grey900" />
        </Flexer.Child>
        {multipleShipperOrders && shipper_order_id && (
          <Flexer.Child mLeft="XS">
            <ShipperOrderTag
              id={shipper_order_id}
              shipperOrdersSkin={shipperOrdersSkin}
              withinGroupage
            />
          </Flexer.Child>
        )}
      </Flexer.Parent>
      <Flexer.Parent alignItems="center" mBottom="XS">
        <Changes action={action} changes={changes} />
      </Flexer.Parent>

      {!!subTitle && (
        <Flexer.Parent mBottom="XS">
          <StyledInline inline={false} bold color="grey700">
            {subTitle}
          </StyledInline>
        </Flexer.Parent>
      )}

      {!!showLogType && (
        <Spacer mBottom="S">
          <SegmentedButton.Parent size="M" value={logType} onChange={handleLogTypeChange}>
            <SegmentedButton.Child value={LOG_INFO} label={t.info} />
            <SegmentedButton.Child value={LOG_INCIDENT} label={t.todo} />
          </SegmentedButton.Parent>
        </Spacer>
      )}
      {!!showReasons && (
        <Spacer mBottom="S">
          <Radios
            legend={''}
            size="M"
            value={reason}
            items={(LOG_REASONS[action] || []).map((reason) => ({
              value: reason,
              label: reasonsText[action][reason] || reason,
            }))}
            onChange={handleReasonChange}
          />
        </Spacer>
      )}
      {showComment && (
        <Textarea
          fullWidth
          value={commentEdited}
          labelType="hidden"
          height={'100px'}
          width={'100%'}
          onChange={handleTextareaChange}
          placeholder={t.textarea_placeholder}
          fieldRef={textAreaRef}
        />
      )}
      <Flexer.Parent mTop="S" mBottom="XS" justifyContent="flex-end">
        <Flexer.Child>
          <Button skin="primary" text={saveButtonText} onClick={handleSaveClick} />
        </Flexer.Child>
      </Flexer.Parent>
    </StyledItem>
  );
};

export default injectIntl(EditModeExtended);
